var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"position":"absolute","border":"none","height":"70%","width":"100%"},attrs:{"src":"https://blog.meterleader.com/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }